import "datatables.net";
import "../components/hs-datatables";
import "flatpickr";
import "../components/hs-range-datepicker";
import "../components/hs-selectpicker";
import "../components/hs-chart-pie";
import "../components/hs-progress-bar";

export default {
  init() {

  },
  finalize() {

    $(window).bind("pageshow", function() {

        $('#occupation option').each(function() {
            if ( $(this).val() != '' ) {
                $(this).prop('selected', false);
            }
        });

        $('#workplacesetting option').each(function() {
            if ( $(this).val() != '' ) {
                $(this).prop('selected', false);
            }
        });

        $('#interests option').each(function() {
            if ( $(this).val() != '' ) {
                $(this).prop('selected', false);
            }
        });

        $('#levelofknowledge option').each(function() {
            if ( $(this).val() != '' ) {
                $(this).prop('selected', false);
            }
        });

        $('#state option').each(function() {
            if ( $(this).val() != '' ) {
                $(this).prop('selected', false);
            }
        });
    });

    $("#occupation").change(function(){

        var len = $("select[name='occupation[]'] option:selected").length;
        
        if(len > 1){
            $("#occupation option[value='']").prop('selected', false);
        }
        if(len == 0){
            $("#occupation option[value='']").prop('selected', true);
        }

        var selected = [];
        $.each($("#occupation option:selected"), function(){            
            selected.push($(this).val());
        });

        if(jQuery.inArray("all", selected) != -1){

            $('#occupation option').each(function() {

                if ( $(this).val() == ''  || $(this).val() == 'novalues' || $(this).val() == 'all') {
                    $(this).prop('selected', false);
                }else { 
                    $(this).prop('selected', true);
                }  

            });

            $(".noneoccupation").removeClass("d-none");
            $(".noneoccupation").show();
            $(".alloccupation").addClass("d-none");
            $(".alloccupation").hide();
            $('#occupation').dropdown('toggle');
        }

        if(jQuery.inArray("novalues", selected) != -1){

            $('#occupation option').each(function() {

                    if ( $(this).val() == '' ) {
                        $(this).prop('selected', true);
                    }else {
                        $(this).prop('selected', false);
                    }
            });

            $(".noneoccupation").addClass("d-none");
            $(".noneoccupation").hide();
            $(".alloccupation").removeClass("d-none");
            $(".alloccupation").show();
            $('#occupation').dropdown('toggle');

        }
    });

    $("#workplacesetting").change(function(){

        var len = $("select[name='workplacesetting[]'] option:selected").length;

        if(len > 1){
            $("#workplacesetting option[value='']").prop('selected', false);
        }
        if(len == 0){
            $("#workplacesetting option[value='']").prop('selected', true);
        }

        var selected = [];
        $.each($("#workplacesetting option:selected"), function(){            
            selected.push($(this).val());
        });

        if(jQuery.inArray("all", selected) != -1){

            $('#workplacesetting option').each(function() {

                if ( $(this).val() == ''  || $(this).val() == 'novalues' || $(this).val() == 'all') {
                    $(this).prop('selected', false);
                }else { 
                    $(this).prop('selected', true);
                }  

            });

            $(".noneworkplacesetting").removeClass("d-none");
            $(".noneworkplacesetting").show();
            $(".allworkplacesetting").addClass("d-none");
            $(".allworkplacesetting").hide();
            $('#workplacesetting').dropdown('toggle');
        }

        if(jQuery.inArray("novalues", selected) != -1){

            $('#workplacesetting option').each(function() {

                    if ( $(this).val() == '' ) {
                        $(this).prop('selected', true);
                    }else {
                        $(this).prop('selected', false);
                    }
            });

            $(".noneworkplacesetting").addClass("d-none");
            $(".noneworkplacesetting").hide();
            $(".allworkplacesetting").removeClass("d-none");
            $(".allworkplacesetting").show();
            $('#workplacesetting').dropdown('toggle');

        }
    });

    $("#interests").change(function(){

        var len = $("select[name='interests[]'] option:selected").length;
        
        if(len > 1){
            $("#interests option[value='']").prop('selected', false);
        }
        if(len == 0){
            $("#interests option[value='']").prop('selected', true);
        }

        var selected = [];
        $.each($("#interests option:selected"), function(){            
            selected.push($(this).val());
        });

        if(jQuery.inArray("all", selected) != -1){

            $('#interests option').each(function() {

                if ( $(this).val() == ''  || $(this).val() == 'novalues' || $(this).val() == 'all') {
                    $(this).prop('selected', false);
                }else { 
                    $(this).prop('selected', true);
                }  

            });

            $(".noneinterests").removeClass("d-none");
            $(".noneinterests").show();
            $(".allinterests").addClass("d-none");
            $(".allinterests").hide();
            $('#interests').dropdown('toggle');
        }

        if(jQuery.inArray("novalues", selected) != -1){

            $('#interests option').each(function() {

                    if ( $(this).val() == '' ) {
                        $(this).prop('selected', true);
                    }else {
                        $(this).prop('selected', false);
                    }
            });

            $(".noneinterests").addClass("d-none");
            $(".noneinterests").hide();
            $(".allinterests").removeClass("d-none");
            $(".allinterests").show();
            $('#interests').dropdown('toggle');
        }
    });

    $("#levelofknowledge").change(function(){

        var len = $("select[name='levelofknowledge[]'] option:selected").length;
        if(len > 1){
            $("#levelofknowledge option[value='']").prop('selected', false);;
        }
        if(len == 0){
            $("#levelofknowledge option[value='']").prop('selected', true);
        }

    });

    $("#state").change(function(){
        var len = $("select[name='state[]'] option:selected").length;
        if(len > 1){
            $("#state option[value='']").prop('selected', false);
        }
        if(len == 0){
            $("#state option[value='']").prop('selected', true);
        }
    });
},
};


// WEBPACK FOOTER //
// ./scripts/routes/training-plan-builder-search.js